export class ServiceInfo {
  constructor(name, peoplewaiting, actualwaittime, active, queueid, segmentid, serviceid)
  {
    this.name = name || null;
    this.peopleWaiting = peoplewaiting;
    this.actualWaitTime = actualwaittime ? actualwaittime : 0;
    this.active = active === 'Y' ? true : active === 'N' ? false : active ; // TODO: This is 'Y' or 'N' for Gala, true or false for NQC. Find a good way to convert.
    this.queueID = queueid ? queueid.toString() : null;
    this.segmentID = segmentid || null;
    this.serviceID = serviceid || null;
  }
}